import {
    BankingAccountType,
    formatDate, ProviderApi,
    ProviderBankingAccount,
    ProviderIntegrationApi, ProviderIntegrationHl7, ProviderIntegrationSftp, ProviderIntegrationTerminal,
    ProviderUser,
    Role
} from '@enter/core';
import faker from 'faker';
import _ from 'lodash';
import { RootStore, waitForNoReason } from 'stores';

export class SettingsGenerator {
    public users: ProviderUser[] = [];
    public roles: Role[] = [];

    public integrationApis: ProviderIntegrationApi[] = [];

    public integrationHl7s: ProviderIntegrationHl7[] = [];

    public integrationSftps: ProviderIntegrationSftp[] = [];

    public integrationTerminals: ProviderIntegrationTerminal[] = [];

    private rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        this.generateEntities(10);
        this.generateRoles();
    }

    public async listProviderUsers(): Promise<ProviderUser[]> {
        await waitForNoReason(400); // add some lag so loader appears
        return this.users;
    }

    public async listProviderIntegrationApis(): Promise<ProviderIntegrationApi[]> {
        await waitForNoReason(100);
        return this.integrationApis;
    }

    public async listProviderIntegrationSftps(): Promise<ProviderIntegrationSftp[]> {
        await waitForNoReason(100);
        return this.integrationSftps;
    }

    public async listProviderIntegrationHl7s(): Promise<ProviderIntegrationApi[]> {
        await waitForNoReason(100);
        return this.integrationHl7s;
    }

    public async listProviderIntegrationTerminals(): Promise<ProviderIntegrationApi[]> {
        await waitForNoReason(100);
        return this.integrationTerminals;
    }

    public async listProviderRoles(): Promise<Role[]> {
        await waitForNoReason(400); // add some lag so loader appears
        return this.roles;
    }

    public async listProviderBankingAccounts(): Promise<ProviderBankingAccount[]> {
        await waitForNoReason(400); // add some lag so loader appears
        return [
            {
                id: faker.random.uuid(),
                name: 'Plaid Gold Standard 0% Interest Checking',
                nickname: 'Plaid Checking',
                institutionName: 'Bank of America',
                account: faker.random.number(1000000000).toString(),
                routing: faker.random.number(1000000000).toString(),
                wire: faker.random.number(1000000000).toString(),
                holderName: `${faker.name.firstName()} ${faker.name.lastName()}`,
                accountType: BankingAccountType.CHECKING,
                forPaymentDeposits: true,
                forFeeCharges: true,
                forMonitoring: true,
                verified: true,
                active: true,
                created: formatDate('Date')(faker.date.past()),
            },
        ];
    }

    private generateEntities(count: number = 3): void {
        _.times(count, () => this.generateProviderUser());
    }

    private generateProviderUser(userId: string = faker.random.uuid()): ProviderUser {
        const user: ProviderUser = {
            userId,
            created: formatDate('Date')(faker.date.past()),
            first: faker.name.firstName(),
            last: faker.name.lastName(),
            phone: faker.phone.phoneNumber(),
            email: faker.internet.exampleEmail(),
            roles: [{ accountId: this.rootStore.account?.grantedAccountId, roleId: 'PROVIDER_ADMIN_ACCESS' }],
        };

        this.users.push(user);
        return user;
    }

    private generateRoles(): void {
        const roles: Role[] = [
            {
                roleId: 'PROVIDER_ADMIN_ACCESS',
                name: 'Admin Access',
                application: 'PROVIDER_DASHBOARD',
                isPublic: true,
            },
            {
                roleId: 'PROVIDER_READ_ACCESS',
                name: 'Read-Only Access',
                application: 'PROVIDER_DASHBOARD',
                isPublic: true,
            },
            {
                roleId: 'PROVIDER_READ_WRITE_ACCESS',
                name: 'Read-Write Access',
                application: 'PROVIDER_DASHBOARD',
                isPublic: true,
            },
        ];

        this.roles = roles;
    }
}
